import React, { useRef } from 'react';
const ContactPage = () => {

    const myMap = useRef();
    const handleClick = (e) => {

        console.log(myMap.current.attributes.src.value)

        myMap.current.attributes.src.value="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d10109.466080470052!2d4.023379847699557!3d50.694582672155505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x47c3b17c70a6deab%3A0xf407495e2791f2cd!2sEnghien%2C%207850%20Enghien!3m2!1d50.6970878!2d4.0470023!4m5!1s0x47c3b220b64a2ac5%3A0xd7c2f2b388cda45d!2sRue%20du%20Village%2050%2C%207850%20Enghien!3m2!1d50.6921197!2d4.0178161999999995!5e0!3m2!1sfr!2sbe!4v1599375967339!5m2!1sfr!2sbe"
    }


    return (
        <>
            <div className="slide" id="contact">
                <div className="sep">
                    Une question ? Un projet ? Parlons-en !
                </div>
                <div className="wrapper container-contact">
                    <div className="gauche">
                        <h2>Viens nous rencontrer et découvre nos formations sur place!</h2>
                        <iframe ref={myMap} id='g_map' src=" https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.506590296966!2d4.015692615871126!3d50.69198307781253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3b220b60b9cc7%3A0x81b95959d74b3155!2sEns+Promo+Sociale+Enghien!5e0!3m2!1sfr!2sbe!4v1480877268176" allowFullScreen></iframe>

                        <div id="clickfoot" onClick={(e)=> handleClick(e)}>ITINÉRAIRE À PIED</div>
                    </div>
                    <div className="droite">
                        <div id="ouverture">
                            <h2>Nous sommes là pour toi</h2>
                            <p>Nous sommes ouverts du lundi au vendredi de 8h15 à 16h (le mercredi jusqu'à 12h) et du lundi au jeudi de 18h25 à 19h30. Besoin de plus de détails ? Rendez-vous sur <a
                                href="https://www.epse.be/contact" className="epse-link">EPSE.be</a> !</p>
                            <div id="info-contact">
                                <div id="adresse"><img src={"images/location.svg"} alt={"Location"}/><strong>Adresse:</strong> 50 rue du village 7850 Enghien</div>
                                <div id="tel"><img src={"images/phone.svg"} alt={"Phone"}/><strong>Téléphone:</strong> 02/395.60.23</div>
                                <div id="email"><img src={"images/envelope.svg"} alt={"Email"}/><strong>Email:</strong> <a href="mailto:info@epse.be">info@epse.be</a></div>
                            </div>
                            <div id="social-contact">
                                <h2>Suis-nous</h2>
                                <a className='social-link' href="https://www.linkedin.com/school/epse/" target="_blank">
                                    <img src="/images/socials/linked.svg" alt="EPSE LinkedIn" />
                                </a>
                                <a className='social-link' href="https://www.facebook.com/EPSEMarcq/" target="_blank">
                                    <img src="/images/socials/facebook.svg" alt="EPSE Facebook" />
                                </a>
                                <a className='social-link' href="https://www.youtube.com/channel/UC33Fs4BdaHlEb5GfDoZzSsA?view_as=subscriber" target="_blank">
                                    <img src="/images/socials/youtube.svg" alt="EPSE YouTube" />
                                </a>
                                <a className='social-link' href="https://www.tiktok.com/@e.p.s.e" target="_blank">
                                    <img src="/images/socials/tiktok.svg" alt="EPSE TikTok" />
                                </a>
                                <a className='social-link' href="https://www.instagram.com/e.p.s.e/" target="_blank">
                                    <img src="/images/socials/insta.svg" alt="EPSE Instagram" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}
 
export default ContactPage;